// extracted by mini-css-extract-plugin
module.exports = {"Support":"A_Support__kVGlh"};